import api, { unwrap } from './client';
import type { ApiResponse } from '@/types/api';
import type { CustomPlanRequestResponse } from './subscriptions.api';

export interface FulfillCustomPlanRequest {
  requestId: number;
  planName?: string;
  description?: string;
  priceMonthly: number;
  priceYearly?: number;
  maxStores?: number;
  maxEmployees?: number;
  maxProducts?: number;
  masterNotes?: string;
}

export const customPlansMasterApi = {
  list: () =>
    unwrap(api.get<ApiResponse<CustomPlanRequestResponse[]>>('/v1/master/custom-plan-requests')),
  fulfill: (body: FulfillCustomPlanRequest) =>
    unwrap(
      api.post<ApiResponse<CustomPlanRequestResponse>>('/v1/master/custom-plan-requests/fulfill', body),
    ),
};
